
<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <th>Sr No.</th>
                  <th>Batch No.</th>
                  <th>Bonus Type</th>
                  <th>Method</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Date</th>
                  <th>Post</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in bonusRecord">
                  <td>{{ind+1}}</td>
                  <td align="left">{{item.BatchNo}}</td>
                  <td align="left">{{item.BonusType}}</td>
                  <td align="left">{{item.Method}}</td>
                  <td align="left">{{item.Month}}</td>
                  <td align="left">{{item.Year}}</td>
                  <td align="left">{{item.Date}}</td>
                  <td align="left">{{item.Post}}</td> 
                  <td>
                    <button class="btn btn-sm btn-primary" v-on:click="edit(item.EmployeeBonusID)">Edit</button>
                    <button class="btn btn-sm btn-primary" v-on:click="print(item.EmployeeBonusID)">Print</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        bonusRecord: []
      }
    },
    created: function () {
      this.pageLoad();
    },
    updated: function () {

     $('#table').DataTable();
    },
    methods: {
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/PayrollApi/loadBonusRecord")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.bonusRecord = res.data.lst;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },

      AddNew() {
        window.location.href = "../Payroll/EmployeeBonus";
      },
      edit(ID) {
        var vm = this;
        axios.post("/api/PayrollApi/EditEmployeeBonus?ID=" + ID)
          .then(function (res) {
            if (res.data.status) {
              window.open(res.data.url, '_blank');
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
      print(ID) {
        var vm = this;
        axios.post("/api/PayrollApi/printEmployeeBonus?ID=" + ID)
          .then(function (res) {
            if (res.data.status) {
              window.open(res.data.url, '_blank');
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/payroll/employeeBonusRecord.vue